import React from "react";
import { useSelector } from "react-redux";
import plural from "plural-ru";

const HeaderInfo = ({ object, isVisual }) => {
	const { roomsCount } = useSelector((state) => state.apartments);
	const isEnglish = document.body.classList.contains("en");

	const complexName = document
		.querySelector("section.chooser")
		?.getAttribute("data-complex-name");

	const showVisual = () => {
		complexName === "Maestro"
			? (location.href = "/projects/maestro/#chooser-visual")
			: (location.href = location.href.split("?")[0] + "?type=visual");
	};

    const showParam = () => {
        location.href = location.href.split("?")[0] + "?type=param"
    }

	const complexRender = document
		.querySelector("section.chooser")
		?.getAttribute("data-complex-render");

	const roomsFoundRu = plural(
		roomsCount,
		"апартамент",
		"апартамента",
		"апартаментов"
	);

	const roomsFoundEn = plural(
		roomsCount,
		"apartment",
		"apartments",
		"apartments"
	);

	return (
		<>
			<div className="pre-header">
				<a href="/projects/">
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="80"
						height="10"
						viewBox="0 0 80 10"
						fill="none"
					>
						<div
							xmlns=""
							id="in-page-channel-node-id"
							data-channel-name="in_page_channel_Ws-fk1"
						/>
						<path
							d="M0 5L7.5 9.33013V0.669873L0 5ZM6.75 5.75H80V4.25H6.75V5.75Z"
							fill="#7AB1D5"
						/>
					</svg>
					<span>{isEnglish ? "back to projects" : "к проектам"}</span>
				</a>
				<div className="view-toggle">
					<button
						className={`chooser-type ${isVisual ? "active" : ""}`}
						onClick={showVisual}
						type="button"
					>
						{isEnglish ? "On plan" : "На плане"}
					</button>
					<button
						className={`${!isVisual ? "active" : ""}`}
						type="button"
                        onClick={showParam}
					>
						{isEnglish ? "By list" : "Списком"}
					</button>
				</div>
				{!isVisual && (
					<h2 className="h4">
						{roomsCount} {isEnglish ? roomsFoundEn : roomsFoundRu}
					</h2>
				)}
			</div>

			<header>
				<picture>
					<img src={complexRender} />
				</picture>
				<div className="info">
					<h1 className="h1">{object.replace(/-/g, " ")}</h1>
					<p>by HARMONY GROUP</p>
				</div>
			</header>
		</>
	);
};

export default HeaderInfo;
